import { NxMessageModule } from '@allianz/ng-aquila/message';
import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-error-page',
  imports: [
    NxMessageModule,
    TranslocoPipe,
  ],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
})
export class ErrorPageComponent {
}
